import React, {Component} from "react"
import {
    Button,
    Card,
    Container,
    Grid,
    Header,
    Icon,
    Image,
    Item,
    Label,
    Message,
    Segment
} from "semantic-ui-react"
import {Link, Switch, Route} from "react-router-dom"
import _ from "lodash"
import MFR from "../presentation/MFR"
import api from "../api"
import HomePage from "./HomePage"
import "./AcceptPage.css"
import Responsive from "react-responsive"
import {useTranslation} from 'react-i18next'
import CancelModal from "./components/Modals/CancelModal"

export default class AcceptPage extends Component {

    constructor() {
        super()
        this.state = {
            active: true
        }
    }

    render() {
        let order = api.getOrder()
        let {match} = this.props
        let isRejected = order.StateCode === "eSubcontractorRejected" || order.StateCode === "eClosed"

        return (
            <div className="transition-item page-accept">
                <Switch>
                    <Route exact path={`${match.url}/new`}
                           component={() => (<AcceptOverlay isRejected={isRejected}
                                                            order={order}/>)}/>
                    <Route exact path={`${match.url}/cancel`}
                           component={() => (<CancelModal order={order}/>)}/>
                    <Route exact path={`${match.url}/details`}
                           component={() => (<DetailModal order={order}/>)}/>
                    <Route exact path={`${match.url}/accepted`} component={() => <HomePage/>}/>
                </Switch>
            </div>
        )
    }
}

const AcceptOverlay = ({order, handleClose, isRejected}) => {
    let appointment = api.getAppointment()

    const {t} = useTranslation();

    return (
        <div className="pt4 pt6-ns pb5 tc">
            <Header icon inverted>
                <div className="din-a4 slide-in"
                     style={{boxShadow: "0 0 120px -30px #fff"}}>
                    {isRejected ? <Label color='red' ribbon style={{top: "6px"}}>{t("general.filed")}</Label> : null}
                    <div className="paper"/>
                    <span className="paper-id black-90">#{order.ExternalId}<br/>
          </span>
                    {appointment
                        ? <span
                            className="paper-time black-50"> {t('intlDateTime', {
                            val: new Date(appointment.StartDateTime),
                            formatParams: {
                                val: { year: 'numeric', month: 'long', day: 'numeric' },
                            },
                        })}
                            <br/>
                            {api.formatDate(appointment.StartDateTime, "HH:mm")} {t("general.to")} {api.formatDate(appointment.EndDateTime, "HH:mm")} {t("general.oclock")}</span>
                        : null}
                    {order.Location
                        ? <span
                            className="paper-address black-50">{order.Location.AddressString}<br/> {order.Location.Postal}&nbsp;{order.Location.City}</span>
                        : null}
                </div>
                <br/>
                <div className="fade-in-delayed pb4 pt3 f3">{order.Name}</div>
                <div className="center fade-in-delayed delay-lg pb3 normal"
                     style={{maxWidth: "720px"}}>
                    {(order.Description) ? <p className="order-description "
                                              dangerouslySetInnerHTML={{__html: order.Description}}/> : <p>...</p>}
                </div>
            </Header>
            <br/>
            <RejectedContact isRejected={isRejected} order={order}/>

            <ActionBar isRejected={isRejected}/>
        </div>
    )
}

const ActionBar = ({isRejected}) => {
    if (isRejected) return null

    const {t} = useTranslation();

    return (
        <div className="ActionBar">
            {/*DESKTOP CTA*/}
            <Responsive minWidth={440}>
                <div className="center tc ">
                    {(!isRejected) ? <Button size="small" as={Link} to="/accept/cancel"
                                             color="red">{t("general.decline")}</Button> : null}
                    {(!isRejected) ? <Button size="small" as={Link} to="/accept/details" basic
                                             inverted>{t("general.details")}</Button> : null}
                    {(!isRejected) ? <Button size="small" as={Link} onClick={() => {
                        api.updateState("eSubcontractorConfirmed")
                    }} to="/accept/accepted" color="green">{t("general.accept")}</Button> : null}
                </div>
            </Responsive>
            {/*MOBILE CTA*/}
            <Responsive maxWidth={440}>
                <div className="center tc fixed bottom-0 w-100 pt3 pb3 bg-white z-999">
                    {(!isRejected) ? <Button size="small" as={Link} to="/accept/cancel"
                                             color="red">{t("general.decline")}</Button> : null}
                    {(!isRejected) ? <Button size="small" as={Link} to="/accept/details"
                                             basic>{t("general.details")}</Button> : null}
                    {(!isRejected) ? <Button size="small" as={Link} onClick={() => {
                        api.updateState("eSubcontractorConfirmed")
                    }} to="/accept/accepted" color="green">{t("general.accept")}</Button> : null}
                </div>
            </Responsive>
        </div>
    )
}



const DetailModal = ({order}) => {
    let person = api.getContact()
    let event = api.getAppointment()
    let isRejected = order.StateCode === "eSubcontractorRejected"
    let docsAttachedToSteps = _.map(order.Steps, (step) => {
        return stepDocuments({step})
    })

    let contacts = api.getContactPersons()
        .map(contact => {
            let company = contact.Company || {}
            return (<p
                key={contact.Id}><Icon
                name="user"/><strong>{contact.FirstName}&nbsp;{contact.LastName} ({company.Name})</strong>
                {contact.Telephone && <div><Icon name="phone"/> {contact.Telephone}</div>}
                {contact.MobilePhone && <div><Icon name="mobile"/> {contact.MobilePhone}</div>}
                {contact.Email && <div><Icon name="mail"/> {contact.Email}</div>}
            </p>)
        })

    let company = person.Company || {}

    const {t} = useTranslation();

    return (
        <div className="white pb5 pb3-ns">
            {/*<Header icon='archive'*/}
            {/*content={`${order.ExternalId} - ${order.Name}`}/>*/}
            <div>
                {(isRejected) ? <Message color='red'>{t("job.decline")}</Message> : null}
                <Container text className="pt5">
                    <Grid>
                        <Grid.Column mobile={5}
                                     tablet={5}
                                     computer={3}
                                     floated='left'
                                     width={3}>
                            <p>
                                <Image src={`${api.baseUrl}/CompanyLogo?token=${api.token}`}
                                       size="small"/>
                            </p>
                        </Grid.Column>
                        <Grid.Column className="tr"
                                     mobile={11}
                                     tablet={5}
                                     computer={5}
                                     floated='right'
                                     width={8}>
                            <strong>{company.Name}</strong>
                            <div>{order.CurrentOwner.FirstName}&nbsp;{order.CurrentOwner.LastName}</div>
                            {order.CurrentOwner.Telephone &&
                                <div><Icon name="phone"/> {order.CurrentOwner.Telephone}</div>}
                            {order.CurrentOwner.MobilePhone &&
                                <div><Icon name="mobile"/> {order.CurrentOwner.MobilePhone}</div>}
                            {order.CurrentOwner.Email && <div><Icon name="mail"/> {order.CurrentOwner.Email}</div>}
                        </Grid.Column>
                    </Grid>
                </Container>
                <Container text className="pt5">
                    <div><span className="f2">{order.ExternalId}
                        - {order.Name}</span><span className="fr"><Icon
                        name="time"/>{order.TargetTimeInMinutes} m</span></div>

                    <p><Icon
                        name="marker"/> {order.Location.AddressString}, {order.Location.Postal}&nbsp;{order.Location.City}&nbsp;
                        <span className=""><a
                            target="_blank"
                            href={`https://maps.google.com?q=${order.Location.AddressString}+${order.Location.Postal}+${order.Location.City}`}>{t("general.showPlace")}</a></span>
                    </p>

                    <p><Icon
                        name="clock"/> {t('intlDateTime', {
                        val: new Date(event.StartDateTime),
                        formatParams: {
                            val: { year: 'numeric', month: 'long', day: 'numeric' },
                        },
                    })}
                        – {api.formatDate(event.StartDateTime, "HH:mm")}
                        {t("general.to")} {api.formatDate(event.EndDateTime, "HH:mm")} {t("general.oclock")}
                    </p>

                    {contacts}

                    {(order.Description) ? <p className="order-description" dangerouslySetInnerHTML={{__html: order.Description}}/> : <p>...</p>}
                </Container>

                <Container textclassName="pt4">
                    <Card.Group className="pb4" itemsPerRow={3} stackable={true}>
                        {docsAttachedToSteps}
                    </Card.Group>

                    {order.Documents.length > 0 &&
                        <div className="mb3">
                            <Segment className="">
                                <h3 className="black-80">{t("general.documents")}</h3>
                                <Item.Group divided>
                                    {documentCategory({documents: order.Documents})}
                                </Item.Group>
                            </Segment>
                        </div>}
                </Container>

            </div>

            <ActionBar isRejected={isRejected}/>
        </div>
    )
}

const RejectedContact = ({isRejected, order}) => {

    const {t} = useTranslation();

    return (
        <div className="white-70">
            {isRejected ? <div>
                {order.CurrentOwner ? <div style={{lineHeight: "18px"}}><strong>{t("general.contact")} {order.CurrentOwner.Company
                    ? <span>{order.CurrentOwner.Company.Name}</span>
                    : null}</strong>
                    <br/>
                    {order.CurrentOwner.FirstName} {order.CurrentOwner.LastName}<br/>
                    <a href={`mailto://${order.CurrentOwner.Email}`}>{order.CurrentOwner.Email}</a>
                    <br/>
                    {order.CurrentOwner.Telephone ? <div>{t("general.phone.phone")} {order.CurrentOwner.Telephone}</div> : null}
                    {order.CurrentOwner.MobilePhone ? <div>{t("general.phone.mobile")} {order.CurrentOwner.MobilePhone}</div> : null}
                </div> : null}
            </div> : null}
        </div>
    )
}

const stepDocuments = ({step}) => {
    return documentCategory({
        documents: step.Attachments, step
    })
}

const documentCategory = ({documents, step = false}) => {
    return _.map(documents, (doc, key) => <MFR.ItemDocument document={doc} key={key} step={step}/>)
}



// WEBPACK FOOTER //
// ./src/pages/AcceptPage.js